import { Typography } from "@material-ui/core";
import Lottie from "lottie-react";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import loaderAnimation from "@/assets/animations/loader.json";

import useStyles from "./Loading.styles";


export const Loading: FC = () => {
    const classes = useStyles();
    const { t } = useTranslation("translation", { keyPrefix: "components.loading" });

    return (
        <div className={classes.loaderContainer}>
            <Lottie animationData={loaderAnimation} title="Loading" loop={true} className={classes.loader} />
            <Typography variant="h6">{t("loading")}</Typography>
        </div>
    );
};
